/* global axios */
import ApiClient from "./ApiClient";
class OmniraEnterprise extends ApiClient {
constructor() {
super("omnira", { accountScoped: true });
}
getKbDocuments() {
return axios.get(`${this.url}/kb_documents`);
}
createKbDocument(data) {
return axios.post(`${this.url}/kb_documents`, data);
}
uploadKbDocument(file, title) {
const formData = new FormData();
formData.append("file", file);
formData.append("title", title || file.name);
return axios.post(`${this.url}/kb_documents`, formData, {
headers: { "Content-Type": "multipart/form-data" },
});
}
updateKbDocument(id, data) {
return axios.put(`${this.url}/kb_documents/${id}`, data);
}
deleteKbDocument(id) {
return axios.delete(`${this.url}/kb_documents/${id}`);
}
getRules() {
return axios.get(`${this.url}/rules`);
}
createRule(data) {
return axios.post(`${this.url}/rules`, data);
}
updateRule(id, data) {
return axios.put(`${this.url}/rules/${id}`, data);
}
deleteRule(id) {
return axios.delete(`${this.url}/rules/${id}`);
}
getLogs() {
return axios.get(`${this.url}/logs`);
}
  tagConversation(conversationDisplayId) {
    return axios.post(`${this.url}/tag_conversation`, { conversation_display_id: conversationDisplayId });
  }
  getPendingLabels() {
    return axios.get(`${this.url}/pending_labels`);
  }
  approvePendingLabel(id) {
    return axios.post(`${this.url}/pending_labels/${id}/approve`);
  }
  rejectPendingLabel(id) {
    return axios.post(`${this.url}/pending_labels/${id}/reject`);
  }

getActivityLogs() {
return axios.get(`${this.url}/activity_logs`);
}
}
export default new OmniraEnterprise();
